<template>
  <div class="h-100">
    <Layout ref="layout">
      <template v-slot:body>
        <Crud
          name="Notificação"
          names="Notificações"
          url="/NotificacaoAdmin"
          :cancreate="false"
          :btns="[{ icon: 'plus', action: 'nova', title: 'Nova notificação' }]"
          @nova="abrirEnvio()"
          @filter="$refs.datatable.applyFilters($event)"
        >
          <template v-slot:list>
            <Datatable
              ref="datatable"
              :fields="fields"
              url="/NotificacaoAdmin/Read"
              :where="where"
              :iniorderby="{ column: 'created', type: 'DESC' }"
              :mobileCardMode="true"
            >
              <template v-slot:resumo="data">
                <div class="notif-resumo">
                  <span class="fw-semibold me-1">{{ data.row.totalDestinatarios }}</span>
                  <span v-if="data.row.totalEnviados" class="badge bg-label-success">{{ data.row.totalEnviados }} enviado{{ data.row.totalEnviados > 1 ? "s" : "" }}</span>
                  <span v-if="data.row.totalSemApp" class="badge bg-label-warning">{{ data.row.totalSemApp }} sem app</span>
                  <span v-if="data.row.totalFalhas" class="badge bg-label-danger">{{ data.row.totalFalhas }} falha{{ data.row.totalFalhas > 1 ? "s" : "" }}</span>
                </div>
              </template>
              <template v-slot:acoes="data">
                <div class="notif-acoes">
                  <i
                    class="tf-icons bx bx-show text-primary notif-acao"
                    title="Ver detalhes"
                    @click="abrirDetalhe(data.row.id)"
                  ></i>
                  <i
                    class="tf-icons bx bx-copy text-primary notif-acao"
                    title="Duplicar"
                    @click="duplicar(data.row.id)"
                  ></i>
                </div>
              </template>
            </Datatable>
          </template>
          <template v-slot:filter="data">
            <div>
              <div class="mb-3">
                <label class="form-label">Título ou mensagem</label>
                <input type="text" class="form-control" v-model="data.filters.titulo" />
              </div>
              <div class="mb-3">
                <label class="form-label">Destinatário (nome ou e-mail)</label>
                <input type="text" class="form-control" v-model="data.filters.destinatario" />
              </div>
            </div>
          </template>
        </Crud>
      </template>
    </Layout>

    <teleport to="body">
      <!-- Envio -->
      <div class="modal fade" ref="modalEnvio" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header bg-primary pb-3">
              <h5 class="modal-title text-white">
                {{ resultado ? "Resultado do envio" : duplicadaDe ? `Nova notificação (cópia de #${duplicadaDe})` : "Nova notificação" }}
              </h5>
              <button type="button" class="btn-close" @click="fecharEnvio" :disabled="enviando"></button>
            </div>

            <div class="modal-body form-modal-body" v-if="!resultado">
              <div v-if="avisoDuplicar" class="alert alert-warning py-2">{{ avisoDuplicar }}</div>
              <div class="mb-3">
                <label class="form-label">Destinatários *</label>
                <VueMultiselect
                  v-model="form.destinatarios"
                  :options="usuarios"
                  :multiple="true"
                  :show-labels="false"
                  :close-on-select="false"
                  :clear-on-select="false"
                  :preserve-search="true"
                  :hide-selected="true"
                  :loading="carregandoUsuarios"
                  :custom-label="labelUsuario"
                  track-by="id"
                  placeholder="Buscar por nome ou e-mail"
                >
                  <template v-slot:option="{ option }">
                    <div class="d-flex justify-content-between align-items-center">
                      <div>
                        <div>{{ option.nome }}</div>
                        <small class="text-muted">{{ option.email }}</small>
                      </div>
                      <span v-if="!option.temApp" class="badge bg-label-warning">sem app</span>
                    </div>
                  </template>
                  <template v-slot:tag="{ option, remove }">
                    <span class="multiselect__tag" :class="{ 'notif-tag-sem-app': !option.temApp }">
                      <span>{{ option.nome }}</span>
                      <i class="multiselect__tag-icon" @click="remove(option)"></i>
                    </span>
                  </template>
                  <template v-slot:noResult>Nenhum usuário encontrado.</template>
                </VueMultiselect>
                <small v-if="semAppSelecionados > 0" class="text-warning d-block mt-1">
                  {{ semAppSelecionados }} destinatário{{ semAppSelecionados > 1 ? "s" : "" }} sem o app instalado:
                  não recebe{{ semAppSelecionados > 1 ? "m" : "" }} o push, só vê{{ semAppSelecionados > 1 ? "em" : "" }} no histórico de alertas.
                </small>
              </div>

              <div class="mb-3">
                <label class="form-label d-flex justify-content-between">
                  <span>Título *</span>
                  <small class="text-muted">{{ form.titulo.length }}/{{ tituloMax }}</small>
                </label>
                <input
                  type="text"
                  class="form-control"
                  v-model="form.titulo"
                  :maxlength="tituloMax"
                  placeholder="Ex.: Manutenção programada"
                />
              </div>

              <div class="mb-3">
                <label class="form-label d-flex justify-content-between">
                  <span>Mensagem *</span>
                  <small :class="form.mensagem.length > mensagemCorte ? 'text-warning' : 'text-muted'">
                    {{ form.mensagem.length }}/{{ mensagemMax }}
                  </small>
                </label>
                <textarea
                  class="form-control"
                  rows="4"
                  v-model="form.mensagem"
                  :maxlength="mensagemMax"
                ></textarea>
                <small v-if="form.mensagem.length > mensagemCorte" class="text-warning">
                  No celular o texto pode aparecer cortado; a mensagem completa fica no histórico de alertas.
                </small>
              </div>

              <label class="form-label">Prévia</label>
              <div class="notif-previa">
                <div class="notif-previa-app">
                  <img src="/img/logo.svg" alt="" />
                  <span>OnAgro</span>
                  <span class="ms-auto">agora</span>
                </div>
                <div class="notif-previa-titulo">{{ form.titulo || "Título da notificação" }}</div>
                <div class="notif-previa-msg">{{ form.mensagem || "Mensagem da notificação" }}</div>
              </div>

              <div v-if="erro" class="alert alert-danger mt-3 mb-0">{{ erro }}</div>
            </div>

            <div class="modal-body form-modal-body" v-else>
              <p class="mb-2">
                <strong>{{ resultado.titulo }}</strong>
              </p>
              <div class="notif-resumo mb-3">
                <span class="badge bg-label-success">{{ resultado.totalEnviados }} enviado{{ resultado.totalEnviados === 1 ? "" : "s" }}</span>
                <span v-if="resultado.totalSemApp" class="badge bg-label-warning">{{ resultado.totalSemApp }} sem app</span>
                <span v-if="resultado.totalFalhas" class="badge bg-label-danger">{{ resultado.totalFalhas }} falha{{ resultado.totalFalhas > 1 ? "s" : "" }}</span>
              </div>
              <ListaDestinatarios :destinatarios="resultado.destinatarios" />
            </div>

            <div class="modal-footer">
              <template v-if="!resultado">
                <button type="button" class="btn btn-secondary" @click="fecharEnvio" :disabled="enviando">Cancelar</button>
                <button type="button" class="btn btn-primary" @click="enviar" :disabled="!podeEnviar || enviando">
                  <span v-if="enviando" class="spinner-border spinner-border-sm me-1"></span>
                  {{ enviando ? "Enviando..." : textoBotaoEnviar }}
                </button>
              </template>
              <button v-else type="button" class="btn btn-primary" @click="fecharEnvio">Fechar</button>
            </div>
          </div>
        </div>
      </div>

      <!-- Detalhe -->
      <div class="modal fade" ref="modalDetalhe" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header bg-primary pb-3">
              <h5 class="modal-title text-white">Notificação enviada</h5>
              <button type="button" class="btn-close" @click="fecharDetalhe"></button>
            </div>
            <div class="modal-body form-modal-body">
              <div v-if="carregandoDetalhe" class="text-center my-4">
                <span class="spinner-border spinner-border-sm"></span>
              </div>
              <div v-else-if="detalhe">
                <p class="text-muted mb-2">
                  {{ formatarData(detalhe.created) }}
                  <span v-if="detalhe.enviadoPorNome"> · por {{ detalhe.enviadoPorNome }}</span>
                </p>
                <h6 class="mb-1">{{ detalhe.titulo }}</h6>
                <p class="notif-detalhe-msg">{{ detalhe.mensagem }}</p>
                <ListaDestinatarios :destinatarios="detalhe.destinatarios" />
              </div>
              <div v-else class="text-center my-4">Não foi possível carregar a notificação.</div>
            </div>
            <div class="modal-footer" v-if="detalhe">
              <button type="button" class="btn btn-primary" @click="duplicarDoDetalhe">
                <i class="bx bx-copy me-1"></i> Duplicar
              </button>
            </div>
          </div>
        </div>
      </div>
    </teleport>

    <Alert ref="alert"></Alert>
  </div>
</template>

<script>
import { h } from "vue";
import VueMultiselect from "vue-multiselect";
import Crud from "../../components/crud/Crud.vue";
import Datatable from "../../components/crud/Datatable.vue";
import Layout from "../../components/layout/Tema.vue";
import Alert from "../../components/Alert.vue";

// Espelha NotificacaoAdminStatus do backend.
const STATUS = {
  0: { texto: "Pendente", classe: "bg-label-secondary" },
  1: { texto: "Enviado", classe: "bg-label-success" },
  2: { texto: "Sem app", classe: "bg-label-warning" },
  3: { texto: "Falhou", classe: "bg-label-danger" },
};

function formatarData(v) {
  return v ? new Date(v).toLocaleString("pt-BR") : "-";
}

// Tabela de destinatários, usada no resultado do envio e no detalhe.
const ListaDestinatarios = {
  props: { destinatarios: { type: Array, default: () => [] } },
  setup(props) {
    return () =>
      h("div", { class: "table-responsive" }, [
        h("table", { class: "table table-sm mb-0" }, [
          h("thead", [h("tr", [h("th", "Destinatário"), h("th", "Status")])]),
          h(
            "tbody",
            props.destinatarios.map((d) => {
              const s = STATUS[d.status] || STATUS[0];
              return h("tr", { key: d.userId }, [
                h("td", [h("div", d.nome), h("small", { class: "text-muted" }, d.email)]),
                h("td", [
                  h("span", { class: "badge " + s.classe, title: d.errorMessage || "" }, s.texto),
                  d.lidaEm
                    ? h("small", { class: "d-block text-success mt-1" }, "Lida em " + formatarData(d.lidaEm))
                    : h("small", { class: "d-block text-muted mt-1" }, "Não lida"),
                  d.excluidoPeloUsuarioEm
                    ? h("small", { class: "d-block text-muted mt-1" }, "Excluída pelo usuário em " + formatarData(d.excluidoPeloUsuarioEm))
                    : null,
                ]),
              ]);
            })
          ),
        ]),
      ]);
  },
};

export default {
  components: { Crud, Datatable, Layout, Alert, VueMultiselect, ListaDestinatarios },
  data() {
    return {
      // Mesmos limites do NotificacaoAdminService.
      tituloMax: 65,
      mensagemMax: 500,
      // A partir daqui a notificação costuma aparecer cortada no celular.
      mensagemCorte: 240,
      usuarios: [],
      carregandoUsuarios: false,
      form: { destinatarios: [], titulo: "", mensagem: "" },
      enviando: false,
      erro: null,
      resultado: null,
      // Id da notificação de origem quando o formulário foi aberto por "Duplicar".
      duplicadaDe: null,
      avisoDuplicar: null,
      detalhe: null,
      carregandoDetalhe: false,
      where: {
        titulo: { operator: "LIKE", replace: "%{value}%" },
        destinatario: { operator: "LIKE", replace: "%{value}%" },
      },
      fields: [
        { name: "ID", value: "id", style: { width: "70px" } },
        {
          name: "Data",
          value: "created",
          style: { width: "170px" },
          format: (v) => formatarData(v),
        },
        { name: "Título", value: "titulo", style: { minWidth: "180px" } },
        {
          name: "Mensagem",
          value: "mensagem",
          orderby: false,
          style: { minWidth: "240px" },
          format: (v) => {
            const t = (v || "").replace(/&/g, "&amp;").replace(/</g, "&lt;");
            return t.length > 80 ? t.slice(0, 80) + "…" : t;
          },
        },
        { name: "Enviado por", value: "enviadoPorNome", style: { minWidth: "140px" } },
        { name: "Destinatários", value: "resumo", type: "slot", orderby: false, style: { minWidth: "200px" } },
        { name: "Ação", value: "acoes", type: "slot", orderby: false, style: { width: "90px", textAlign: "center" } },
      ],
    };
  },
  computed: {
    semAppSelecionados() {
      return this.form.destinatarios.filter((u) => !u.temApp).length;
    },
    podeEnviar() {
      return (
        this.form.destinatarios.length > 0 &&
        this.form.titulo.trim().length > 0 &&
        this.form.mensagem.trim().length > 0
      );
    },
    textoBotaoEnviar() {
      const n = this.form.destinatarios.length;
      return n > 0 ? `Enviar para ${n} usuário${n > 1 ? "s" : ""}` : "Enviar";
    },
  },
  methods: {
    formatarData,
    labelUsuario(u) {
      return `${u.nome} — ${u.email}`;
    },
    carregarUsuarios() {
      this.carregandoUsuarios = true;
      return this.urlGet("/NotificacaoAdmin/Usuarios")
        .then((res) => {
          this.usuarios = res.data || [];
        })
        .catch(() => {
          this.usuarios = [];
          this.$refs.alert.show("Erro", "Não foi possível carregar os usuários.", null, 5000, "bg-danger");
        })
        .finally(() => {
          this.carregandoUsuarios = false;
        });
    },
    // origem: notificação já enviada (resposta do GET por id) para pré-preencher o formulário.
    abrirEnvio(origem = null) {
      this.form = {
        destinatarios: [],
        titulo: origem ? origem.titulo : "",
        mensagem: origem ? origem.mensagem : "",
      };
      this.erro = null;
      this.resultado = null;
      this.duplicadaDe = origem ? origem.id : null;
      this.avisoDuplicar = null;
      // Recarrega para o selo "sem app" refletir tokens registrados desde a última abertura.
      this.carregarUsuarios().then(() => {
        if (origem) this.preencherDestinatarios(origem.destinatarios || []);
      });
      $(this.$refs.modalEnvio).modal({ backdrop: "static", keyboard: false });
    },
    preencherDestinatarios(destinatarios) {
      const porId = new Map(this.usuarios.map((u) => [u.id, u]));
      const encontrados = destinatarios.map((d) => porId.get(d.userId)).filter(Boolean);
      this.form.destinatarios = encontrados;

      // Usuário excluído desde o envio original não aparece mais na lista de usuários.
      const removidos = destinatarios.length - encontrados.length;
      if (removidos > 0) {
        this.avisoDuplicar =
          removidos === 1
            ? "1 destinatário da notificação original não existe mais e foi removido."
            : `${removidos} destinatários da notificação original não existem mais e foram removidos.`;
      }
    },
    duplicar(id) {
      this.urlGet("/NotificacaoAdmin/" + id)
        .then((res) => this.abrirEnvio(res.data))
        .catch(() => {
          this.$refs.alert.show("Erro", "Não foi possível carregar a notificação.", null, 5000, "bg-danger");
        });
    },
    duplicarDoDetalhe() {
      const origem = this.detalhe;
      this.fecharDetalhe();
      // Espera o modal de detalhe fechar para não empilhar dois backdrops.
      setTimeout(() => this.abrirEnvio(origem), 400);
    },
    fecharEnvio() {
      if (this.enviando) return;
      $(this.$refs.modalEnvio).modal("hide");
    },
    enviar() {
      if (!this.podeEnviar || this.enviando) return;
      this.enviando = true;
      this.erro = null;
      this.urlPost("/NotificacaoAdmin", {
        userIds: this.form.destinatarios.map((u) => u.id),
        titulo: this.form.titulo.trim(),
        mensagem: this.form.mensagem.trim(),
      })
        .then((res) => {
          this.resultado = res.data;
          this.$refs.datatable.update();
        })
        .catch((e) => {
          // Sem resposta (timeout/rede): o backend segue enviando mesmo assim, então
          // reenviar duplicaria o push.
          if (!e.response) {
            this.erro =
              "Sem resposta do servidor. O envio pode ter sido feito: confira a lista antes de reenviar.";
            this.$refs.datatable.update();
            return;
          }
          this.erro =
            (e.response.data && e.response.data.message) ||
            "Não foi possível enviar a notificação.";
        })
        .finally(() => {
          this.enviando = false;
        });
    },
    abrirDetalhe(id) {
      this.detalhe = null;
      this.carregandoDetalhe = true;
      $(this.$refs.modalDetalhe).modal({ backdrop: "static", keyboard: false });
      this.urlGet("/NotificacaoAdmin/" + id)
        .then((res) => {
          this.detalhe = res.data;
        })
        .catch(() => {
          this.detalhe = null;
        })
        .finally(() => {
          this.carregandoDetalhe = false;
        });
    },
    fecharDetalhe() {
      $(this.$refs.modalDetalhe).modal("hide");
    },
  },
  beforeUnmount() {
    $(this.$refs.modalEnvio).modal("hide");
    $(this.$refs.modalDetalhe).modal("hide");
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.css"></style>
<style>
.notif-resumo {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
}
.notif-acoes {
  display: flex;
  justify-content: center;
  gap: 10px;
}
.notif-acao {
  cursor: pointer;
  font-size: 1.2rem;
}
.notif-tag-sem-app {
  background: #fff2d6;
  color: #b37400;
}
.notif-previa {
  max-width: 360px;
  background: #f5f5f9;
  border: 1px solid #d9dee3;
  border-radius: 12px;
  padding: 10px 12px;
}
.notif-previa-app {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.75rem;
  color: #8592a3;
  margin-bottom: 4px;
}
.notif-previa-app img {
  width: 16px;
  height: 16px;
}
.notif-previa-titulo {
  font-weight: 600;
  color: #384551;
  word-break: break-word;
}
.notif-previa-msg {
  font-size: 0.875rem;
  color: #566a7f;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-word;
}
.notif-detalhe-msg {
  white-space: pre-wrap;
  word-break: break-word;
}
</style>
